import baseApi from "../api/baseApi";

const activityLogApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllActivityLogs: builder.query({
      query: ({
        page = 1,
        limit = 10,
        startDate,
        endDate,
        search = "",
        actionType = "",
      }) => {
        const params = new URLSearchParams({
          page,
          limit,
          ...(startDate && { startDate }),
          ...(endDate && { endDate }),
          ...(search && { search }),
          ...(actionType && actionType !== "All" && { actionType }),
        });
        return `/activitylogs/getAllActivityLogs?${params.toString()}`;
      },
    }),

    getAllActivityTypes: builder.query({
      query: () => "/activitytypes/getAllActivityTypes",
    }),
  }),
});

export const { useGetAllActivityLogsQuery, useGetAllActivityTypesQuery } =
  activityLogApi;
